import './lib/custom/extension';
import '@iotize/tap';

import { BodyConverter } from '@iotize/tap/client/api';

import { VariableMetaConfigConverter } from './lib/custom/converters';
import { VariableMeta } from './lib/generated/models';
import { SERVICE_CALLS } from './lib/generated/service-calls';

export * from './lib/generated/public_api';
export { VariableMetaConfigConverter };

// Replace generated converter as there is a bug in generated converter (decoding does not split info with character ':')
const variableMetaConfigConverter =
  new VariableMetaConfigConverter() as BodyConverter<VariableMeta>;
SERVICE_CALLS.getMeta.responseBodyDecoder = variableMetaConfigConverter;
SERVICE_CALLS.putMeta.bodyEncoder = variableMetaConfigConverter;
